import React from 'react';
import jc from './jc.png'

class hd202112 extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    // document.title = '服务协议';
    return (
        <div className="page_type_h5">
            <article id="hd202112">
                <img src={jc} style={{width: '100%'}} />
            </article>
        </div>
    );
  }
}

export default hd202112;



// WEBPACK FOOTER //
// ./src/staticPage/hd202112/index.js